import React, { useEffect, useState } from "react";
import "./FinanceReport.scss";
import { TitleBar } from "../../../Global/TitleBar/TitleBar";
import { TopBar } from "../../TopBar/TopBar";
import {
  Description,
  GreenSubDescription,
  PaymentPendingHeading,
} from "../../../Global/GlobalText";
import { IoMdArrowDropleft, IoMdArrowDropright } from "react-icons/io";
import { CheckboxInput } from "../../../Global/GlobalFormElement";
import { RxCrossCircled } from "react-icons/rx";
import { GreyBorderButton } from "../../../Global/GlobalButton";
import axios from "axios";
import { EXCHNAGE_UR_PAYMENTSL, EXCHNAGE_URL } from "../../../../Url/Url";
import { toast } from "react-toastify";
import { useSearchParams } from "react-router-dom";
import { useSelector } from "react-redux";
import * as XLSX from "xlsx";

export const FinanceReport = () => {
  const [columns, setColumns] = useState([]); 
  const [selectedColumns, setSelectedColumns] = useState([]); 
  const [selectedAvailable, setSelectedAvailable] = useState([]); 
  const [selectedSelected, setSelectedSelected] = useState([]); 
  const [data, setData] = useState([]);

  const token = localStorage.getItem("token");
  const eventIdGet = useSelector((state) => state?.users?.id);
  const eventId = String(eventIdGet);
const fetchColumnsAndData = async () => {
  try {
    const response = await axios.get(
      `${EXCHNAGE_UR_PAYMENTSL}/orderlistforevent/${eventId}`,
      { headers: { Authorization: `Bearer ${token}` } }
    );
    
    if (response.data.success) {
      const uniqueColumns = response.data.data.columns.reduce((acc, column) => {
        if (!acc.includes(column)) {
          acc.push(column);
        }
        return acc;
      }, []);

      setColumns(uniqueColumns);
      setData(response.data.data.data);
    }
  } catch (error) {
    console.error("Error fetching data", error);
  }
};

useEffect(()=>{
  fetchColumnsAndData();
},[])

  const availableColumns = columns.filter(
    (col) => !selectedColumns.includes(col)
  );

  const toggleSelectedAvailable = (column) => {
    setSelectedAvailable((prev) =>
      prev.includes(column)
        ? prev.filter((c) => c !== column)
        : [...prev, column]
    );
  };

  const handleSelectAllAvailable = () => {
    setSelectedAvailable(availableColumns);
  };

  const handleDeselectAllAvailable = () => {
    setSelectedAvailable([]);
  };

  const toggleSelectedSelected = (column) => {
    setSelectedSelected((prev) =>
      prev.includes(column)
        ? prev.filter((c) => c !== column)
        : [...prev, column]
    );
  };

  const handleSelectAllSelected = () => {
    setSelectedSelected(selectedColumns);
  };

  const handleDeselectAllSelected = () => {
    setSelectedSelected([]);
  };

  const handleMoveToSelected = () => {
    setSelectedColumns((prev) => [...prev, ...selectedAvailable]);
    setSelectedAvailable([]);
  };

  const handleMoveToAvailable = () => {
    setSelectedColumns((prev) =>
      prev.filter((col) => !selectedSelected.includes(col))
    );
    setSelectedSelected([]);
  };

  const handleRemoveFromSelected = (column) => {
    setSelectedColumns((prev) => prev.filter((c) => c !== column));
  };

  const handleExportCsv = () => {
    if (selectedColumns.length === 0) {
      toast.error("Please select at least one column to export.");
      return;
    }

    const filteredData = data.map((row) =>
      selectedColumns.reduce((acc, col) => {
        acc[col] = row[col] || "";
        return acc;
      }, {})
    );

    const worksheet = XLSX.utils.json_to_sheet(filteredData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Finance Report");
    XLSX.writeFile(workbook, "Finance_Report.xlsx");
    toast.success("File downloaded successfully");
  };

  return (
    <div>
      <div className="financereport_data_div">
        <TitleBar title="Finance Report" />
        <div className="financereport_white_bg">
          <TopBar titleheading="Finance Report" />
          <div className="financereport_main">
            <GreenSubDescription>
              Select and re-Arrange your columns
            </GreenSubDescription>

            <div className="financereport_column_head">
              <PaymentPendingHeading>Available Columns</PaymentPendingHeading>
              <div className="financereport_arrow_icon">
                <IoMdArrowDropleft onClick={handleMoveToAvailable} />
                <IoMdArrowDropright onClick={handleMoveToSelected} />
              </div>
              <PaymentPendingHeading>Selected Columns</PaymentPendingHeading>
            </div>

            <div className="financereport_check_section">
              {/* Available Columns Section */}
              <div className="financereport_sub_check" style={{ backgroundColor: "#FFE2E54D" }}>
                <div className="financereport_heading">
                  <h4 onClick={handleSelectAllAvailable} style={{ cursor: "pointer" }}>
                    Select All
                  </h4>
                  <h4 onClick={handleDeselectAllAvailable} style={{ cursor: "pointer" }}>
                    Deselect All
                  </h4>
                </div>
                <div className="financereport_checbox_div">
                  <Description>Submission</Description>
                  {availableColumns.map((column) => (
                    <div key={column} className="section_four_checkbox">
                      <CheckboxInput
                        type="checkbox"
                        checked={selectedAvailable.includes(column)}
                        onChange={() => toggleSelectedAvailable(column)}
                      />
                      <Description>{column.replace(/_/g, " ")}</Description>
                    </div>
                  ))}
                </div>
              </div>

              {/* Selected Columns Section */}
              <div className="financereport_sub_check" style={{ backgroundColor: "#F6F8F9" }}>
                <div className="financereport_heading">
                  <h4 onClick={handleSelectAllSelected} style={{ cursor: "pointer" }}>
                    Select All
                  </h4>
                  <h4 onClick={handleDeselectAllSelected} style={{ cursor: "pointer" }}>
                    Deselect All
                  </h4>
                </div>
                <div className="financereport_newchecbox_div">
                  {selectedColumns.map((column) => (
                    <div key={column} className="section_four_new_checkbox">
                      <div className="newww_check">
                        <CheckboxInput
                          type="checkbox"
                          checked={selectedSelected.includes(column)}
                          onChange={() => toggleSelectedSelected(column)}
                        />
                        <Description>{column.replace(/_/g, " ")}</Description>
                      </div>
                      <RxCrossCircled
                        onClick={() => handleRemoveFromSelected(column)}
                        style={{ cursor: "pointer", color: "#333333", marginLeft: "10px" }}
                      />
                    </div>
                  ))}
                </div>
              </div>
            </div>

            <div className="financereport_btn">
              <GreyBorderButton onClick={handleExportCsv}>Export</GreyBorderButton>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};